export default "__VITE_ASSET__NAlZHGeB__"